import { RootState } from "../../store/types";
import { SeminarModel } from "../../api";
import { AsyncEntity } from "../_shared/action-model-async";

export const getCurrentSeminar = (state: RootState): AsyncEntity<SeminarModel, number> => state.seminars.current;
